export default {
  batchNo: '碼批次',
  batchNoPlaceholder: '請輸入碼批次',
  qrcode: '二維碼',
  qrcodePlaceholder: '請輸入二維碼',
  colBatchNo: '碼批次',
  colQrcodeRange: '二維碼區間',
  colQrcodeCount: '二維碼數量',
  colDescription: '碼批次說明',
  colCreatedAt: '添加時間',
  colRemark: '備註',
  colAction: '操作',
  editRemark: '編輯備註',
  editRemarkTitle: '編輯備註',
  remark: '備註',
  remarkPlaceholder: '請輸入備註內容',
  emptyText: '暫無碼批次數據',
  batchSn: '碼批次',
  batchSnPlaceholder: '請輸入碼批次',
  colBatchSn: '碼批次',
  colName: '碼批次名稱',
  colCodeRange: '二維碼區間',
  colCodeCount: '二維碼數量',
  colCodeRemark: '碼批次說明',
  colStatus: '狀態',
  colUpdatedAt: '更新時間',
};
